'use client';

import { useState } from 'react';
import s from './styles.module.scss';
import Image from 'next/image';

import { items } from '../../../mocks/faq';

export const Faq = () => {
    const [openIndexes, setOpenIndexes] = useState<number[]>([]);

    const toggleIndex = (idx: number) => {
        setOpenIndexes((prev) =>
            prev.includes(idx) ? prev.filter((i) => i !== idx) : [...prev, idx]
        );
    };

    return (
        <section className={s.root}>
            <div className={s.faqList}>
                {items.map((item, idx) => (
                    <div className={s.faqItem} key={idx} onClick={() => toggleIndex(idx)}>
                        <div className={s.questionRow}>
                            <h3 className={s.question}>{item.question}</h3>
                            <button
                                className={
                                    s.arrow + (openIndexes.includes(idx) ? ' ' + s.open : '')
                                }
                                onClick={() => toggleIndex(idx)}
                                aria-label={openIndexes.includes(idx) ? 'Закрити' : 'Відкрити'}
                            >
                                <Image
                                    className={s.arrowIcon}
                                    src="/icons/arrow.svg"
                                    alt=""
                                    width={40}
                                    height={15}
                                    onClick={() => toggleIndex(idx)}
                                />
                            </button>
                        </div>

                        <p className={`${s.answer} ${openIndexes.includes(idx) ? s.open : ''}`}>
                            {item.answer}
                        </p>
                    </div>
                ))}
            </div>
        </section>
    );
};
